import axios from 'axios'

// 创建axios实例
const service = axios.create({
  baseURL: '/api', // 使用代理前缀
  timeout: 10000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 排除登录接口的token验证
    if (!config.url.includes('/auth/login')) {
      // 从localStorage获取token并添加到请求头
      const token = localStorage.getItem('token')
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token
      }
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 可以根据后端返回的状态码进行不同的处理
    if (res.code && res.code !== 200) {
      console.error('接口返回错误:', res.message || '未知错误')
      return Promise.reject(new Error(res.message || '未知错误'))
    } else {
      return res
    }
  },
  error => {
    console.error('响应错误:', error)
    return Promise.reject(error)
  }
)

export default service